import React, { Component } from 'react';

function B(props) {
    return <div className="B" onClick={props.callback}>
        {props.title}
    </div>
}

export default (B);